import type { LabelHTMLAttributes } from "react";
import { cn } from "@rosette/ts/src/util/cn.js";


/**
 * The name of a form field, above its input. Put a HelpButton after the
 * text to explain the field.
 */
export function Label({ className, ...props }: LabelHTMLAttributes<HTMLLabelElement>) {
    return (
        <label
            {...props}
            className={cn(
                "mt-3 flex flex-row items-center text-base font-bold text-strong",
                className ?? null,
            )} />
    );
}
